export const SYSTEM_PROPS = {
  m: {
    type: 'spacing',
    property: 'margin'
  },
  mt: {
    type: 'spacing',
    property: 'marginBlockStart'
  },
  mb: {
    type: 'spacing',
    property: 'marginBlockEnd'
  },
  ml: {
    type: 'spacing',
    property: 'marginInlineStart'
  },
  mr: {
    type: 'spacing',
    property: 'marginInlineEnd'
  },
  mx: {
    type: 'spacing',
    property: 'marginInline'
  },
  my: {
    type: 'spacing',
    property: 'marginBlock'
  },
  p: {
    type: 'spacing',
    property: 'padding'
  },
  pt: {
    type: 'spacing',
    property: 'paddingBlockStart'
  },
  pb: {
    type: 'spacing',
    property: 'paddingBlockEnd'
  },
  pl: {
    type: 'spacing',
    property: 'paddingInlineStart'
  },
  pr: {
    type: 'spacing',
    property: 'paddingInlineEnd'
  },
  px: {
    type: 'spacing',
    property: 'paddingInline'
  },
  py: {
    type: 'spacing',
    property: 'paddingBlock'
  },
  w: {
    type: 'size',
    property: 'width'
  },
  miw: {
    type: 'size',
    property: 'minWidth'
  },
  maw: {
    type: 'size',
    property: 'maxWidth'
  },
  h: {
    type: 'size',
    property: 'height'
  },
  mih: {
    type: 'size',
    property: 'minHeight'
  },
  mah: {
    type: 'size',
    property: 'maxHeight'
  },
  bg: {
    type: 'color',
    property: 'background'
  },
  c: {
    type: 'color',
    property: 'color'
  },
  fill: {
    type: 'color',
    property: 'fill'
  },
  opacity: {
    type: 'identity',
    property: 'opacity'
  },
  pos: {
    type: 'identity',
    property: 'position'
  },
  top: {
    type: 'spacing',
    property: 'insetBlockStart'
  },
  left: {
    type: 'spacing',
    property: 'insetInlineStart'
  },
  bottom: {
    type: 'spacing',
    property: 'insetBlockEnd'
  },
  right: {
    type: 'spacing',
    property: 'insetInlineEnd'
  },
  inset: {
    type: 'spacing',
    property: 'inset'
  },
  display: {
    type: 'identity',
    property: 'display'
  },
  flex: {
    type: 'identity',
    property: 'flex'
  },
  flexGrow: {
    type: 'identity',
    property: 'flexGrow'
  },
  flexShrink: {
    type: 'identity',
    property: 'flexShrink'
  },
  flexBasis: {
    type: 'identity',
    property: 'flexBasis'
  },
  alignContent: {
    type: 'identity',
    property: 'alignContent'
  },
  alignItems: {
    type: 'identity',
    property: 'alignItems'
  },
  alignSelf: {
    type: 'identity',
    property: 'alignSelf'
  },
  flexDirection: {
    type: 'identity',
    property: 'flexDirection'
  },
  justifyContent: {
    type: 'identity',
    property: 'justifyContent'
  },
  flexWrap: {
    type: 'identity',
    property: 'flexWrap'
  },
  order: {
    type: 'identity',
    property: 'order'
  },
  gap: {
    type: 'spacing',
    property: 'gap'
  },
  overflow: {
    type: 'identity',
    property: 'overflow'
  },
  overflowX: {
    type: 'identity',
    property: 'overflowX'
  },
  overflowY: {
    type: 'identity',
    property: 'overflowY'
  },
  zIndex: {
    type: 'identity',
    property: 'zIndex'
  },
  ta: {
    type: 'identity',
    property: 'textAlign',
    transform: value => {
      if (value === 'left') {
        return 'start';
      }

      if (value === 'right') {
        return 'end';
      }

      return value;
    }
  },
  tal: {
    type: 'identity',
    property: 'textAlignLast',
    transform: value => {
      if (value === 'left') {
        return 'start';
      }

      if (value === 'right') {
        return 'end';
      }

      return value;
    }
  },
  va: {
    type: 'identity',
    property: 'verticalAlign'
  },
  fontSize: {
    type: 'size',
    property: 'fontSize'
  },
  fw: {
    type: 'identity',
    property: 'fontWeight'
  },
  b: {
    type: 'identity',
    property: 'border'
  },
  bs: {
    type: 'identity',
    property: 'borderStyle'
  },
  bc: {
    type: 'color',
    property: 'borderColor'
  },
  bw: {
    type: 'size',
    property: 'borderWidth'
  },
  btw: {
    type: 'size',
    property: 'borderBlockStartWidth'
  },
  bbw: {
    type: 'size',
    property: 'borderBlockEndWidth'
  },
  blw: {
    type: 'size',
    property: 'borderInlineStartWidth'
  },
  brw: {
    type: 'size',
    property: 'borderInlineEndWidth'
  },
  br: {
    type: 'size',
    property: 'borderRadius'
  },
  btr: {
    type: 'size',
    property: ['borderStartStartRadius', 'borderStartEndRadius']
  },
  bbr: {
    type: 'size',
    property: ['borderEndStartRadius', 'borderEndEndRadius']
  },
  btlr: {
    type: 'size',
    property: 'borderStartStartRadius'
  },
  btrr: {
    type: 'size',
    property: 'borderStartEndRadius'
  },
  bblr: {
    type: 'size',
    property: 'borderEndStartRadius'
  },
  bbrr: {
    type: 'size',
    property: 'borderEndEndRadius'
  },
  transition: {
    type: 'identity',
    property: 'transition'
  },
  transform: {
    type: 'identity',
    property: 'transform'
  },
  backgroundImage: {
    type: 'identity',
    property: 'backgroundImage'
  },
  backgroundSize: {
    type: 'identity',
    property: 'backgroundSize'
  },
  backgroundRepeat: {
    type: 'identity',
    property: 'backgroundRepeat'
  },
  backgroundPosition: {
    type: 'identity',
    property: 'backgroundPosition'
  },
  objectFit: {
    type: 'identity',
    property: 'objectFit'
  },
  aspectRatio: {
    type: 'identity',
    property: 'aspectRatio'
  },
  outline: {
    type: 'identity',
    property: 'outline'
  },
  textShadow: {
    type: 'identity',
    property: 'textShadow'
  },
  boxShadow: {
    type: 'shadow',
    property: 'boxShadow'
  },
  pointerEvents: {
    type: 'identity',
    property: 'pointerEvents'
  },
  filter: {
    type: 'identity',
    property: 'filter'
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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